import { FormGroup } from '@angular/forms';

export const markAllFormFieldsAsTouched = (form: FormGroup, ignore?: string[]) => {
  Object.keys(form.controls).forEach((key) => {
    const control = form.controls[key];

    if (control instanceof FormGroup) {
      markAllFormFieldsAsTouched(control, ignore);
    } else {
      if (!ignore?.includes(key)) {
        control.markAsTouched();
        control.markAsDirty();
      }
    }
  });
};

export const scrollToFirstError = () => {
  setTimeout(() => {
    document.querySelector('.text-aux-error')?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  });
};
